import { useTranslation } from 'react-i18next'

import { AcknowledgeModal, Modal } from '@percent/lemonade'

export type DeleteCampaignSuccessModalProps = Readonly<{
  isOpen: boolean
  handleClose: () => void
}>

export function DeleteCampaignSuccessModal({ isOpen, handleClose }: DeleteCampaignSuccessModalProps) {
  const { t } = useTranslation()

  return (
    <Modal open={isOpen} onClose={handleClose} aria-labelledby="publish-campaign-success">
      <AcknowledgeModal
        result="positive"
        title={t('typography.givingCampaigns.deleteCampaign.success.title')}
        buttonText={t('button.done')}
        handleClose={handleClose}
        buttonTestId="success-modal-btn"
      >
        {t('typography.givingCampaigns.deleteCampaign.success.description')}
      </AcknowledgeModal>
    </Modal>
  )
}
